import { type FC } from 'react';

import { MermaidRow } from './MermaidRow';
import { type MermaidRow as MermaidRowType } from '@/data/blog/types';

interface MermaidGalleryProps {
  heading?: string;
  caption?: string;
  rows: MermaidRowType[];
}

export const MermaidGallery: FC<MermaidGalleryProps> = ({ heading, caption, rows }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <section className="w-full py-12">
      <div className="mx-auto flex w-full max-w-[96rem] flex-col gap-6">
        {heading || caption ? (
          <header className="flex flex-col gap-3 border-b border-zinc-200 pb-4 font-montreal text-zinc-900 md:flex-row md:items-end md:justify-between dark:border-white/15 dark:text-white">
            {heading ? (
              <h4 className="text-[1.85rem] font-light tracking-tight text-zinc-900 dark:text-white">
                {heading}
              </h4>
            ) : (
              <span aria-hidden className="sr-only">Diagram Gallery</span>
            )}
            {caption ? (
              <p className="text-base text-zinc-600 md:max-w-sm md:text-right dark:text-white/75">{caption}</p>
            ) : null}
          </header>
        ) : null}

        <div className="flex flex-col gap-6">
          {rows.map((row, index) => (
            <MermaidRow
              key={`${row.layout}-${index}`}
              layout={row.layout}
              diagrams={row.diagrams}
            />
          ))}
        </div>

        {!heading && caption ? (
          <p className="mt-2 text-sm text-white/60">{caption}</p>
        ) : null}
      </div>
    </section>
  );
};

export default MermaidGallery;
